

const DEBUG = window.location.hash.match('DEBUG')

const nop = function() {}
const log = console.log.bind(window.console)
const trace = console.debug.bind(window.console)
const warn = console.warn.bind(window.console)
const error = console.error.bind(window.console)

/**
 * PortalLogging
 */
module.exports = class PortalLogging {

  /**
   * ### trace(...args)
   * ### log(...args)
   * ### warn(...args)
   * ### error(...args)
   *
   * Conditionally `console.log`/`console.warn` if DEBUG is in the hash of the url
   */
  static get trace() {return ! DEBUG ? nop : trace}
  static get log() {return ! DEBUG ? nop : log}
  static get warn() {return ! DEBUG ? nop : warn}
  static get error() {return ! DEBUG ? nop : error}

}



//////////////////
// WEBPACK FOOTER
// ./js/PortalLogging.js
// module id = 0
// module chunks = 0